module.exports = "/assets/data/26d3c223738a9ca88337f2f827eaff6b-NG18.data.json";